const downloadCascadePermissionCases = [
  ['can_sharing'],
  ['can_delete', 'can_sharing'],
];  

export default downloadCascadePermissionCases;
